module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.dialogVisiable,
      "show-close": true,
      "center": true,
      "before-close": _vm.closeDialog,
      "append-to-body": _vm.appendToDialog,
      "close-on-click-modal": false,
      "custom-class": "common-confirm-dialog",
      "width": "300px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisiable = $event
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "iconfont",
    class: _vm.icon,
    style: ({
      color: _vm.iconColor
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "common-confirm-info"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirmOK
    }
  }, [_vm._v(_vm._s(_vm.$t("btn.confirm")))])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a6df71f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a6df71f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonConfirm.vue
// module id = 1585
// module chunks = 7